"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAILURE = exports.SUCCESS = exports.START = exports.SAGA = void 0;
var SAGA = 'apiFlow/customTableViews/save/SAGA';
exports.SAGA = SAGA;
var START = 'apiFlow/customTableViews/save/START';
exports.START = START;
var SUCCESS = 'apiFlow/customTableViews/save/SUCCESS';
exports.SUCCESS = SUCCESS;
var FAILURE = 'apiFlow/customTableViews/save/FAILURE';
exports.FAILURE = FAILURE;